// extracted by mini-css-extract-plugin
export var backdropBlur = "_jq-0";
export var contentCard = "_jq-5";
export var frame = "_jq-2";
export var image = "_jq-4";
export var imagePane = "_jq-3";
export var modal = "_jq-1";